module.exports = __webpack_public_path__ + "img/48.dd066536.png";